import React from "react";
import { Info } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "../ui/tooltip";

/**
 * Tiny inline tooltip for non-obvious admin fields.
 *
 * Usage:
 *   <label>Fallback rate <InfoTooltip>Day-rate Opus's unknown roles fall back to…</InfoTooltip></label>
 *
 * Renders a 14px Info icon that, on hover/focus, shows the tooltip body.
 * Always wrapped in its own TooltipProvider so callers don't have to.
 */
const InfoTooltip = ({ children, testid }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="More info"
          className="inline-flex items-center justify-center align-middle ml-1 text-zinc-400 hover:text-[#7737F6] focus:text-[#7737F6] focus:outline-none"
          data-testid={testid}
        >
          <Info size={13} />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        className="bg-[#0B0B0C] text-white text-[12px] max-w-xs px-3 py-2 leading-snug font-light"
      >
        {children}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default InfoTooltip;
